export default "__VITE_ASSET__CyqFH48Y__"